import _ from 'lodash'
import Vue from 'vue'
import * as mutationTypes from '../store/mutation-types'

const formatMoney = function (value) {
  if (!_.isNumber(value)) {
    return value
  }
  return value.toFixed(2) + '元'
}

const schoolKey = window.SCHOOL_KEY

const berthTypeMap = {
  UPPER: '上铺',
  LOWER: '下铺'
}

const getBerthTypeValue = function (key) {
  if (key) {
    return berthTypeMap[key]
  }
}

Vue.prototype.$getBerthTypeValue = function (value) {
  return getBerthTypeValue(value)
}

Vue.prototype.$formatMoney = function (value) {
  return formatMoney(value)
}

Vue.prototype.$getBaseUrl = function () {
  return window.API_BASE_URL
}

Vue.prototype.$t_school = function (key) {
  return this.$t(`${schoolKey}.${key}`)
}

Vue.prototype.$getSchoolKey = function () {
  return schoolKey
}

Vue.prototype.$showLoading = function (text) {
  if (_.isEmpty(text)) {
    text = '加载中...'
  }
  this.$store.commit(mutationTypes.SET_LOADING, {show: true, text: text})
}

Vue.prototype.$hiddenLoading = function () {
  this.$store.commit(mutationTypes.SET_LOADING, {show: false, text: ''})
}

Vue.prototype.$showToast = function (message, type) {
  if (_.isEmpty(type)) {
    type = 'success'
  }
  this.$vux.toast.show({
    type: type,
    text: message,
    time: 1000
  })
}

const _isValid = function (vue, refNames) {
  let foundInvalidRef = _.find(refNames, function (refName) {
    return !vue.$refs[refName].$data.valid
  })
  return _.isEmpty(foundInvalidRef)
}

Vue.prototype.$watchValid = function (objectPath, refNames, $callback) {
  if (_.isEmpty(refNames)) {
    $callback(true)
    return
  }
  let vue = this
  this.$watch(objectPath, function () {
    $callback(_isValid(vue, refNames))
  }, {
    deep: true
  })
  $callback(_isValid(vue, refNames))
}

const PAYMENT_STATUS_NO_INVOICE = 'NO_INVOICE'
const PAYMENT_STATUS_PAID = 'PAID'
const USER_TYPE_STUDENT = 'STUDENT'

Vue.prototype.$safePaymentStatus = function (paymentStatus, step) {
  let type = this.$store.state.currentUser.type
  if (paymentStatus === PAYMENT_STATUS_NO_INVOICE || paymentStatus === PAYMENT_STATUS_PAID) {
    return paymentStatus
  }
  if (type === USER_TYPE_STUDENT) {
    return paymentStatus
  }
  if (step === 'INVOICE') {
    return paymentStatus
  }
  return 'NO_INVOICE'
}



// WEBPACK FOOTER //
// ./src/components/functions.js